import { API_URL } from 'constants';

export const DEFAULT_HOLIDAY_URL = `${API_URL}/api/v1/holiday`;
export const HOLIDAYS_BY_DATES_URL = `${API_URL}/api/v1/holiday/holidays-by-dates`;
export const UPCOMING_HOLIDAYS_URL = `${API_URL}/api/v1/holiday/upcoming-holidays`;